import React, { useState } from "react";

import { Tooltip } from "reactstrap";

export default function MyToolTip(props) {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <Tooltip
      placement={props.placement}
      isOpen={tooltipOpen}
      target={props.target}
      toggle={() => setTooltipOpen(!tooltipOpen)}
      delay={{ show: 0, hide: 0 }}
    >
      {props.text}
    </Tooltip>
  );
}
